import React from "react";
import { useFormContext } from "react-hook-form";
import {
  FormField,
  FormField2,
  FormField2Sign,
  FormField3,
  FormField2SignWith2Label,
  FormFieldNoLabel,
} from "./form-fields";
import { ValidationOptions } from "react-hook-form/dist/types";

type FormInputProps = {
  type: string;
  mustMatch?: string;
  rule?: ValidationOptions;
};
type FormInputLabelProps = {
  type: string;
  label: string;
  label2?: string;
  mustMatch?: string;
  rule?: ValidationOptions;
};

export const FormInput = ({
  type,
  name,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };

  return (
    <FormField error={errors[inputName] && errors[inputName]!.message}>
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
    </FormField>
  );
};
export const FormInputLabel = ({
  type,
  name,
  label,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputLabelProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };

  return (
    <FormField2
      error={errors[inputName] && errors[inputName]!.message}
      label={label}
    >
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
    </FormField2>
  );
};

export const FormInputLabel2 = ({
  type,
  name,
  label,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputLabelProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };

  return (
    <FormField3
      error={errors[inputName] && errors[inputName]!.message}
      label={label}
    >
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
    </FormField3>
  );
};
export const FormInputLabelDollarSignOutSide = ({
  type,
  name,
  label,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputLabelProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };
  return (
    <FormFieldNoLabel error={errors[inputName] && errors[inputName]!.message}>
      <span className="dollarOutside">$</span>
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
    </FormFieldNoLabel>
  );
};
export const FormInputLabelSign = ({
  type,
  name,
  label,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputLabelProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };
  return (
    <FormField2Sign
      error={errors[inputName] && errors[inputName]!.message}
      label={label}
    >
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
      <span className="icon is-left dollarSign">$</span>
    </FormField2Sign>
  );
};
export const FormInputLabelSignWith2Label = ({
  type,
  name,
  label,
  label2,
  placeholder,
  rule,
  mustMatch,
  ...props
}: FormInputLabelProps &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >) => {
  const { register, errors, getValues } = useFormContext();
  const inputName = name || type;
  const inputPlaceholder =
    placeholder || type.charAt(0).toUpperCase() + type.slice(1);

  if (mustMatch)
    rule = {
      ...rule,
      validate: () =>
        getValues()[inputName] === getValues()[mustMatch] || "must match",
    };
  return (
    <FormField2SignWith2Label
      error={errors[inputName] && errors[inputName]!.message}
      label={label}
      label2={label2}
    >
      <input
        className="input"
        type={type}
        name={inputName}
        placeholder={inputPlaceholder}
        ref={rule ? register(rule) : register}
        {...props}
      />
      <span className="icon is-left dollarSign">$</span>
    </FormField2SignWith2Label>
  );
};

export const FormTextarea = ({
  name,
  placeholder,
  rule,
}: {
  name: string;
  placeholder?: string;
  rule?: ValidationOptions;
}) => {
  const { register, errors } = useFormContext();

  return (
    <FormField error={errors[name] && errors[name]!.message}>
      <textarea
        className="textarea"
        ref={rule ? register(rule) : register}
        placeholder={placeholder}
        name={name}
      />
    </FormField>
  );
};
export const FormTextareaOrange = ({
  name,
  placeholder,
  rule,
}: {
  name: string;
  placeholder?: string;
  rule?: ValidationOptions;
}) => {
  const { register, errors } = useFormContext();

  return (
    <FormField error={errors[name] && errors[name]!.message}>
      <textarea
        id="textareaOragne"
        className="labelOrange"
        ref={rule ? register(rule) : register}
        placeholder={placeholder}
        name={name}
      />
    </FormField>
  );
};
